import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";
import { inputBorderRadiusMedium } from "src/styles/components/constants";

export const senecOutlinedInputTheme = (theme: SenecFPPTheme) => {
    return {
        styleOverrides: {
            root: {
                backgroundColor: theme.palette.neutralGray000.main,
                borderRadius: inputBorderRadiusMedium,
                color: theme.palette.neutralGray100.main,
                legend: {
                    display: "none",
                },
            },
        },
    };
};
